// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvu2gc{padding-left:var(--ds-space-100,8px)}\n._ca0qpxbi{padding-top:var(--ds-space-200,1pc)}\n._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
